import { Row } from 'antd';

import { useFetchPopularSearchData } from 'Pages/Home/Hooks/useFetchPopularSearchData';
import { useFetchSettingData } from 'Pages/Home/Hooks/useFetchSettingData';
import { useHistory } from 'react-router';
import { categorySearch, categoryURL } from '../../../../../../utils/Helpers';
import ButtonCard from '../../Atoms/ButtonCard';
import Styles from './PopularSearch.module.scss';
import { TPopularSearch } from './definitions';
import useSaveSearch from 'Pages/Home/Hooks/useSaveSearch';

export default function PopularSearch({
  afterClick,
  category,
  userId,
}: TPopularSearch) {
  const history = useHistory();
  const { data: _data } = useFetchPopularSearchData('', 6);
  const { data: kaFairSettingsData } = useFetchSettingData('ka_fair_event');
  const { data } = useFetchSettingData('popular_keyword');

  const pathname = history?.location?.pathname;
  const haveCategory =
    /\b(sneakers|apparel|luxury|electronics-collectibles|madeindonesia)\b/.test(
      pathname,
    );
  const trimmedCategory = pathname.replace('/', '');
  const isSearchURL = pathname?.includes('/search');
  const splitPathname = pathname?.split('/');
  const dataCategory = returnCategory();

  function returnCategory() {
    if (!haveCategory) return 'all_category';
    if (haveCategory && isSearchURL) return categorySearch(splitPathname[2]);
    if (haveCategory && !isSearchURL) return categorySearch(splitPathname[1]);
  }

  const { postSaveSearchActivity } = useSaveSearch({
    category: returnCategory(),
    userId,
  });

  const onPopularSearchClick = (url: string) => {
    const keyword = url.split('=')[1].split('+').join(' ');
    if (userId) {
      postSaveSearchActivity(keyword);
    }
    history.push(`${url}`);
    afterClick();
  };
  const onBrowseAllClick = () => {
    if (returnCategory() !== 'all_category')
      history.push(`/search/${categoryURL(returnCategory())}`);
    else history.push(`/browse-all`);
    afterClick();
  };

  const onKaFairClick = () => {
    history.push(`/sneakers`);
    afterClick();
  };

  return (
    <Row className={Styles['popular-search-row']}>
      <ButtonCard
        text="Browse All"
        bold
        className={Styles['popular-search-item']}
        onClick={onBrowseAllClick}
      />
      {/* {kaFairSettingsData && kaFairSettingsData.length !== 0 && (
        <ButtonCard
          text={kaFairSettingsData}
          eventCard
          className={Styles['popular-search-item']}
          onClick={onKaFairClick}
        />
      )} */}
      {data?.[dataCategory]?.map((item, index) => {
        return (
          <ButtonCard
            className={Styles['popular-search-item']}
            text={item?.keyword}
            key={index}
            onClick={() => onPopularSearchClick(item?.URL)}
          />
        );
      })}
    </Row>
  );
}
